import useToggle from "./useToggle";
import { useState, useEffect } from "react";
import LogMessage from "../components/misc/LogMessage";
import { wait } from "@testing-library/user-event/dist/utils";
import { waitTo } from "../utils/others";
import { milliseconds } from "date-fns";

const useLogMessage = () => {
  const { isToggled, toggle, setIsToggled } = useToggle(false);
  const [time, setTime] = useState<number | null>(null);
  const [message, setMessage] = useState({
    subject: "",
    other_text: "",
    complement: "",
    bgColor: "",
  });

  const resetMessage = () => {
    setMessage({ subject: "", other_text: "", complement: "", bgColor: "" });
  };

  useEffect(() => {
    if (isToggled) {
      if (time === null) {
        waitTo(3000, () => {
          setIsToggled(false);
          resetMessage();
        });
      } else if (time !== null) {
        waitTo(time, () => {
          setIsToggled(false);
          resetMessage();
        });
      }
    }
  }, [isToggled, time]);

  const write = (paramName: string, value: string) => {
    setMessage((prevMessage) => ({ ...prevMessage, [paramName]: value }));
    setIsToggled(true);
  };

  const setMessageTimer = (milliseconds: number | null) => {
    setTime(milliseconds);
  };

  return { message, write, isToggled, setMessageTimer };
};
export default useLogMessage;
